import { EmptyState } from '@app/components/base/EmptyState';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import { defineMessage, FormattedMessage } from 'react-intl';

const streamQualityReportEmptyHelp = defineMessage({
  id: 'logger.reports.streamQuality.emptyState.help',
  defaultMessage: 'Elige rango y emisoras para generar el reporte.',
});

/**
 * Placeholder shown before the first stream quality report run (no API result yet).
 */
export function StreamQualityReportEmptyState() {
  return (
    <EmptyState
      icon={AssessmentOutlinedIcon}
      message={false}
      help={<FormattedMessage {...streamQualityReportEmptyHelp} />}
    />
  );
}
